import { useState, useEffect } from 'react';
import {json, useLoaderData} from 'react-router-dom';
import { getLanguageLevelSeries } from '../common/api';
import {Row, Col, Card, Button} from 'react-bootstrap';

import ItemsListComponent from '../components/ItemsList.component';
import FiltersComponent from '../components/Filters.component';
import LevelsComponent from '../components/Levels.component';

export async function loader({params}){
  const langageLevelSeries = await getLanguageLevelSeries(params.language, params.level);
  return json({data: langageLevelSeries, currentLevel: params.level, language: params.language});
}


const SelectSeriesPage = () => {
  const data = useLoaderData();

  const [selectedSeries, setSelectedSeries] = useState([]);
  const [items, setItems] = useState(data.data.data.items);

  const handleFilters = async (filter) => {
    const isValueSelected = selectedSeries.includes(filter);
    if (isValueSelected) {
      const updatedSeries = selectedSeries.filter((value) => value !== filter);
      await setSelectedSeries(updatedSeries);
    } else {
      await setSelectedSeries((prevSeries) => [...prevSeries, filter]);
    }
  }

  useEffect(() => {
    if(selectedSeries.length > 0){
      setItems(data.data.data.items.filter(item => selectedSeries.includes(item.series)))
    }
    else{
      setItems(data.data.data.items);
    }
  }, [selectedSeries]);


  return(
    <>
      <Row>
        <Col sm="12" md="3" lg="3">
          <div><FiltersComponent language={data.language} data={data.data.data.series} handleFilters={handleFilters} /></div>
          <div><LevelsComponent language={data.language} selectedLevel={data.currentLevel} data={data.data.data.levels} /></div>
        </Col>
        <Col sm="12" md="9" lg="9">
          <div><ItemsListComponent language={data.language} data={items}/></div>
        </Col>
      </Row>
    </>
  )

}
export const Component = SelectSeriesPage;